import { SizableText, XStack, XStackProps } from 'tamagui'

type ErrorProps = {
  error: string
} & XStackProps

export const Error = ({ error }: ErrorProps) => {
  return (
    <XStack>
      <SizableText size="$3" py="$1" color="$red11">
        {error}
      </SizableText>
    </XStack>
  )
}
